import type { RouteLocationNormalized } from 'vue-router';
import type { RouterListener } from './RouterListener';
import { useIsAnonymousStore } from '@/vue/stores/isAnonymous';

export default class AnonymousRouteListener implements RouterListener {
    public onBeforeEach(to: RouteLocationNormalized): boolean {
        const isAnonymousStore = useIsAnonymousStore();
        isAnonymousStore.updateRouteState(to);

        return true;
    }
}
